import request from '@/utils/request'

const prefix = '/django_rest/notification'

export default {

  createTemplate (params) {
    return request.post(`${prefix}/template/`, params)
  },

  updateTemplate (params) {
    return request.put(`${prefix}/template/${params.id}/`, params)
  },

  getTemplateById (id) {
    return request.get(`${prefix}/template/${id}/`)
  },

  deleteTemplate (id) {
    return request.delete(`${prefix}/template/${id}/`)
  },

  searchTemplate (params) {
    return request.get(`${prefix}/template/`, { params: params })
  },

  createLayoutTemplate (params) {
    return request.post(`${prefix}/layout-template/`, params)
  },

  updateLayoutTemplate (params) {
    return request.put(`${prefix}/layout-template/${params.id}/`, params)
  },

  getLayoutTemplateById (id) {
    return request.get(`${prefix}/layout-template/${id}/`)
  },

  deleteLayoutTemplate (id) {
    return request.delete(`${prefix}/layout-template/${id}/`)
  },

  searchLayoutTemplate (params) {
    return request.get(`${prefix}/layout-template/`, { params: params })
  },

  updateSystemTemplate (params) {
    return request.put(`${prefix}/template-system/${params.id}/`, params)
  },

  getSystemTemplateById (id) {
    return request.get(`${prefix}/template-system/${id}/`)
  },

  createSystemLayoutTemplate (params) {
    return request.post(`${prefix}/layout-template-system/`, params)
  },

  updateSystemLayoutTemplate (params) {
    return request.put(`${prefix}/layout-template-system/${params.id}/`, params)
  },

  getSystemLayoutTemplateById (id) {
    return request.get(`${prefix}/layout-template-system/${id}/`)
  },

  deleteSystemLayoutTemplate (id) {
    return request.delete(`${prefix}/layout-template-system/${id}/`)
  },

  searchSystemTemplate (params) {
    return request.get(`${prefix}/template-system/`, { params: params })
  },

  searchSystemLayoutTemplate (params) {
    return request.get(`${prefix}/layout-template-system/`, { params: params })
  },

  searchTemplateField (id) {
    return request.get(`${prefix}/template-type/${id}/fields`)
  },

  sendEmail (params) {
    return request.post(`${prefix}/sending-email/`, params)
  },
  getCompanyEmailTemplateByType (params) {
    return request.get(`${prefix}/company/email-template/`, { params })
  },
  getCompanyInterviewEmailTemplate (params) {
    return request.get(`${prefix}/company/interview-email-template/`, { params })
  },
  getCompanyInviteHmRateEmailTemplate (params) {
    return request.get(`${prefix}/company/invite-hm-rate-template/`, { params })
  }
}
